import { ForwardedRef, forwardRef } from "react";

import { TextAreaRef } from "antd/es/input/TextArea";
import { FieldValues, useController } from "react-hook-form";
import { z } from "zod";

import { StringInput, StringInputBaseProps } from "../fields/stringInput";

import { BaseRHFWidgetProps } from "./types";

interface RHFStringInputProps<TFieldsValues extends FieldValues>
    extends BaseRHFWidgetProps<TFieldsValues, string>, StringInputBaseProps {
    schema: z.ZodString;
}

export const RHFStringInput = forwardRef(
    <TFieldsValues extends FieldValues>(
        {
            label,
            placeholder,
            maxRows,
            name,
            control,
            schema,
            disabled,
            styleVariant,
            autoFocus,
            onKeyDown,
        }: RHFStringInputProps<TFieldsValues>,
        forwardedRef: ForwardedRef<TextAreaRef>
    ) => {
        const { field, fieldState } = useController({
            name,
            control,
            disabled,
        });
        const required = schema.minLength ? schema.minLength > 0 : false;
        const minLength = schema.minLength;
        const maxLength = schema.maxLength;
        return (
            <StringInput
                label={label}
                value={field.value}
                onChange={field.onChange}
                onBlur={field.onBlur}
                error={fieldState.error?.message}
                placeholder={placeholder}
                maxRows={maxRows}
                disabled={field.disabled}
                styleVariant={styleVariant}
                autoFocus={autoFocus}
                minLength={minLength ?? undefined}
                maxLength={maxLength ?? undefined}
                required={required}
                fieldRef={field.ref}
                ref={forwardedRef}
                onKeyDown={onKeyDown}
            />
        );
    }
);
